import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _reduce from "lodash/reduce";

var _CREDIT_CARDS_REWARD_, _MORTGAGES_LOAN_TYPE_, _MORTGAGES_LOAN_PRODU, _FEDERALLY_INSURED_AN;

/**
 * Re-export driver constants for convenience.
 */
export * from './drivers';
/**
 * Marketplace entity types.
 *
 * Should match https://github.com/NerdWallet/marketplace/blob/faed250b44abc10ef708221669bba4b03b43b711/src/marketplace/constants.py#L68.
 *
 * @type       {Object}
 */

export var ENTITY_TYPES = {
  INSTITUTIONS: 'institutions',
  OFFERS: 'offers',
  PRODUCTS: 'products'
};
/**
 * Marketplace product types.
 * Should match @see {@link https://github.com/NerdWallet/marketplace/blob/c9fc15a7c9bdd2b47987de8a64e26ada33f5d46a/src/marketplace/constants.py#L105-L121}.
 * @enum {string}
 */

export var PRODUCT_TYPES = {
  AUTO_LOANS: 'auto_loans',
  BANKING: 'banking',
  CREDIT_CARDS: 'credit_cards',
  EDUCATION_LOANS: 'education_loans',
  FTHB_PROGRAMS: 'first_time_home_buyer_programs',
  INSURANCE: 'insurance',
  INVESTING: 'investing',
  MORTGAGES: 'mortgages',
  PERSONAL_LOANS: 'personal_loans',
  SMB_LOANS: 'small_medium_business_loans',
  SOFTWARE: 'software'
};
export var IMAGE_PLACEHOLDERS = _defineProperty({}, PRODUCT_TYPES.CREDIT_CARDS, '//cdn.nerdwallet.com/img/cc/CC_placeholder.svg');
export var IMAGE_SIZES = {
  MEDIUM: 'medium',
  LARGE: 'large'
};
/**
 * Banking product display pages.
 *
 * Should match https://github.com/NerdWallet/marketplace/blob/26112b7cf259d68af5c58ab10933af7b56047d61/src/schemas/banking/offer_details.json#L54-L67
 *
 * @type       {Object}
 */

export var BANKING_DISPLAY_PAGES = {
  MARKETPLACE: 'MARKETPLACE',
  TOOLS: 'TOOLS',
  CONTENT: 'CONTENT',
  REVIEWS: 'REVIEWS',
  COMPARISON: 'COMPARISON',
  IPX_CARDS: 'IPX_CARDS',
  PERSONALIZED_REC_FLOWS: 'PERSONALIZED_REC_FLOWS',
  DIGITAL_MARKETING: 'DIGITAL_MARKETING',
  ROUNDUPS: 'ROUNDUPS'
};
/**
 * Auto Loans product sub product types.
 *
 * Should match https://github.com/NerdWallet/marketplace/blob/3843342e9d3aaf4a50c4bd8d90f8aad5287ed8c6/src/schemas/auto_loans/product_details.json#L5
 *
 * @type       {Object}
 */

export var AUTO_LOANS_SUB_PRODUCT_TYPES = {
  PURCHASE: 'Purchase',
  PURCHASE_NEW: 'Purchase - New',
  PURCHASE_USED: 'Purchase - Used',
  REFINANCE: 'Refinance',
  LEASE_BUYOUT: 'Lease Buyout'
};
/**
 * Banking product sub product types.
 *
 * Should match https://github.com/NerdWallet/marketplace/blob/9936e3215e11ede93351560758a0f21c1ed5d83e/src/schemas/banking/product_details.json#L60-L68
 *
 * @type       {Object}
 */

export var BANKING_SUB_PRODUCT_TYPES = {
  CASH_MANAGEMENT: 'CASH_MANAGEMENT',
  CD: 'CD',
  CHECKING: 'CHECKING',
  MONEY_MARKET: 'MONEY_MARKET',
  PREMIUM_MONEY_MARKET: 'PREMIUM_MONEY_MARKET',
  SAVINGS: 'SAVINGS'
};
/**
 * Banking product audience types.
 *
 * Should match https://github.com/NerdWallet/marketplace/blob/master/src/schemas/global/product_details.json#L1-L11
 *
 * @type       {Object}
 */

export var PRODUCT_AUDIENCE_TYPE = {
  BUSINESS: 'business',
  CONSUMER: 'consumer'
};
/**
 * Enum for Credit Card reward rate types.
 * @enum {string}
 */

export var CREDIT_CARDS_REWARD_RATE_TYPES = {
  PERCENT: 'percent',
  CASH: 'cash',
  MILES: 'miles',
  POINTS: 'points'
};
/**
 * Enum for Credit Card reward types.
 * Used for both Reward Rate and Intro Offer.
 * @enum {string}
 */

export var CREDIT_CARDS_REWARD_TYPES = {
  CASH: 'CASH',
  MILES: 'MILES',
  POINTS: 'POINTS',
  NO_REWARDS: 'NO REWARDS'
};
/**
 * Map reward types to descriptions.
 * This map is used for both Reward Rate and Intro Offer
 * @type {Object.<string, string>}
 */

export var CREDIT_CARDS_REWARD_TYPE_DESCRIPTIONS = (_CREDIT_CARDS_REWARD_ = {}, _defineProperty(_CREDIT_CARDS_REWARD_, CREDIT_CARDS_REWARD_TYPES.MILES, 'Miles'), _defineProperty(_CREDIT_CARDS_REWARD_, CREDIT_CARDS_REWARD_TYPES.POINTS, 'Points'), _CREDIT_CARDS_REWARD_);
/**
 * Education Loans offer loan types.
 *
 * Should match https://github.com/NerdWallet/marketplace/blob/1a7f6cdec19c88c4b31812c34344c3fd1fd77092/src/schemas/education_loans/offer_details.json#L192-L208
 *
 * @type       {Object}
 */

export var EDUCATION_LOANS_OFFER_TYPES = {
  BAR_EXAM: 'BAR_EXAM',
  DENTAL: 'DENTAL',
  FEDERAL_GRADUATE: 'FEDERAL_GRADUATE',
  FEDERAL_PARENT: 'FEDERAL_PARENT',
  FEDERAL_STUDENT: 'FEDERAL_STUDENT',
  GRADUATE: 'GRADUATE',
  LAW: 'LAW',
  MBA: 'MBA',
  MEDICAL: 'MEDICAL',
  PARENT: 'PARENT',
  PHARMACY: 'PHARMACY',
  PRIVATE: 'PRIVATE',
  REFINANCE: 'REFINANCE',
  RESIDENCY: 'RESIDENCY',
  VETERINARY: 'VETERINARY'
};
/**
 * Education Loans product sub product types.
 *
 * Currently no defined matches in marketplace (freeform text field)
 *
 * @type       {Object}
 */

export var EDUCATION_LOANS_SUB_PRODUCT_TYPES = {
  ORIGINATION: 'Origination',
  REFINANCE: 'Refinance'
};
/**
 * Investing product sub product types.
 *
 * Should match https://github.com/NerdWallet/marketplace/blob/44030a82b26b37ec5bde13379afafa11adc84f22/src/schemas/investing/product_details.json#L118-L121
 *
 * @type       {Object}
 */

export var INVESTING_SUB_PRODUCT_TYPES = {
  BROKER: 'Broker',
  INVESTMENT_ADVISOR: 'Investment Advisor'
};
/**
 * Mortgage canonical loan types from Marketplace.
 *
 * Should match {@link https://github.com/NerdWallet/marketplace/blob/de42516f6cbf816dbbff3184cff042cf278f4474/src/schemas/mortgages/offer_details.json#L19-L26}
 *
 * @type {Object}
 */

export var MORTGAGES_CANONICAL_LOAN_TYPES = {
  CASHOUT: 'CASHOUT',
  CONVENTIONAL: 'CONVENTIONAL',
  FHA: 'FHA',
  HEL: 'HEL',
  HELOC: 'HELOC',
  JUMBO: 'JUMBO',
  USDA: 'USDA',
  VA: 'VA'
};
/**
 * Mortgage canonical coverage area from Marketplace.
 *
 * Should match {@link https://github.com/NerdWallet/marketplace/blob/de42516f6cbf816dbbff3184cff042cf278f4474/src/schemas/mortgages/offer_details.json#L102-L103}
 *
 * @type {Object}
 */

export var MORTGAGES_COVERAGE_AREAS = {
  NATIONAL: 'NATIONAL',
  REGIONAL: 'REGIONAL'
};
/**
 * The Mortgage sub product types.
 *
 * Should match {@link https://github.com/NerdWallet/marketplace/blob/de42516f6cbf816dbbff3184cff042cf278f4474/src/schemas/mortgages/product_details.json#L10-L12}
 *
 * @type {Object}
 */

export var MORTGAGES_SUB_PRODUCT_TYPES = {
  HOME_EQUITY: 'HOME_EQUITY',
  PURCHASE: 'PURCHASE',
  REFINANCE: 'REFINANCE'
};
/**
 * WordPress lender object loan types.
 *
 * Should match https://github.com/NerdWallet/wp/blob/cf78fa9aa87528f5a618e7092acd629b5a9034ef/src/wp-content/mu-plugins/nerdwallet-config/config/meta-fields.json#L1286
 *
 * @type {Object}
 * @deprecated
 */

export var MORTGAGES_LOAN_TYPES = {
  CONVENTIONAL: 'conventional',
  HEL: 'hel',
  HELOC: 'heloc',
  HOME_EQUITY: 'home_equity',
  JUMBO: 'jumbo',
  PURCHASE: 'purchase',
  REFINANCE: 'refinance',
  REVERSE: 'reverse'
};
/**
 * WordPress lender object loan type labels.
 *
 * Should match https://github.com/NerdWallet/wp/blob/cf78fa9aa87528f5a618e7092acd629b5a9034ef/src/wp-content/mu-plugins/nerdwallet-config/config/meta-fields.json#L1286
 *
 * @type {Object}
 * @deprecated
 */

export var MORTGAGES_LOAN_TYPE_LABELS = (_MORTGAGES_LOAN_TYPE_ = {}, _defineProperty(_MORTGAGES_LOAN_TYPE_, MORTGAGES_LOAN_TYPES.CONVENTIONAL, 'Conventional'), _defineProperty(_MORTGAGES_LOAN_TYPE_, MORTGAGES_LOAN_TYPES.HEL, 'HEL'), _defineProperty(_MORTGAGES_LOAN_TYPE_, MORTGAGES_LOAN_TYPES.HELOC, 'HELOC'), _defineProperty(_MORTGAGES_LOAN_TYPE_, MORTGAGES_LOAN_TYPES.HOME_EQUITY, 'Home Equity'), _defineProperty(_MORTGAGES_LOAN_TYPE_, MORTGAGES_LOAN_TYPES.JUMBO, 'Jumbo'), _defineProperty(_MORTGAGES_LOAN_TYPE_, MORTGAGES_LOAN_TYPES.PURCHASE, 'Purchase'), _defineProperty(_MORTGAGES_LOAN_TYPE_, MORTGAGES_LOAN_TYPES.REFINANCE, 'Refinance'), _defineProperty(_MORTGAGES_LOAN_TYPE_, MORTGAGES_LOAN_TYPES.REVERSE, 'Reverse'), _MORTGAGES_LOAN_TYPE_);
/**
 * WordPress lender object loan products.
 *
 * Should match https://github.com/NerdWallet/wp/blob/cf78fa9aa87528f5a618e7092acd629b5a9034ef/src/wp-content/mu-plugins/nerdwallet-config/config/meta-fields.json#L1303
 *
 * @type {Object}
 * @deprecated
 */

export var MORTGAGES_LOAN_PRODUCTS = {
  ADJUSTABLE: 'adjustable',
  CASHOUT: 'cashout',
  FHA: 'fha',
  FIXED: 'fixed',
  USDA: 'usda',
  VA: 'va'
};
/**
 * WordPress lender object loan product labels.
 *
 * Should match https://github.com/NerdWallet/wp/blob/cf78fa9aa87528f5a618e7092acd629b5a9034ef/src/wp-content/mu-plugins/nerdwallet-config/config/meta-fields.json#L1303
 *
 * @type {Object}
 * @deprecated
 */

export var MORTGAGES_LOAN_PRODUCT_LABELS = (_MORTGAGES_LOAN_PRODU = {}, _defineProperty(_MORTGAGES_LOAN_PRODU, MORTGAGES_LOAN_PRODUCTS.ADJUSTABLE, 'Adjustable'), _defineProperty(_MORTGAGES_LOAN_PRODU, MORTGAGES_LOAN_PRODUCTS.CASHOUT, 'Cashout'), _defineProperty(_MORTGAGES_LOAN_PRODU, MORTGAGES_LOAN_PRODUCTS.FHA, 'FHA'), _defineProperty(_MORTGAGES_LOAN_PRODU, MORTGAGES_LOAN_PRODUCTS.FIXED, 'Fixed'), _defineProperty(_MORTGAGES_LOAN_PRODU, MORTGAGES_LOAN_PRODUCTS.USDA, 'USDA'), _defineProperty(_MORTGAGES_LOAN_PRODU, MORTGAGES_LOAN_PRODUCTS.VA, 'VA'), _MORTGAGES_LOAN_PRODU);
/**
 * Mortages featured loan attributes.
 *
 * Should match {@link https://github.com/NerdWallet/marketplace/blob/de42516f6cbf816dbbff3184cff042cf278f4474/src/schemas/mortgages/institution_details.json#L30-L39}
 *
 * @type {Object}
 */

export var MORTGAGES_FEATURED_LOAN_ATTRIBUTES = {
  ADJUSTABLE: 'ADJUSTABLE',
  FHA: 'FHA',
  FIXED: 'FIXED',
  HOME_EQUITY: 'HOME_EQUITY',
  JUMBO: 'JUMBO',
  PURCHASE: 'PURCHASE',
  REFINANCE: 'REFINANCE',
  REVERSE: 'REVERSE',
  USDA: 'USDA',
  VA: 'VA'
};
/**
 * Mapping from loan attribute & type enum to displayed label.
 * As a subset of the union between legacy Mortgage loan types and Mortgage loan products, featured loan attributes can leverage prior label definitions.
 *
 * @type {Object<String>}
 */

export var MORTGAGES_FEATURED_LOAN_ATTRIBUTES_TO_LABELS = _reduce(_objectSpread(_objectSpread({}, MORTGAGES_CANONICAL_LOAN_TYPES), MORTGAGES_FEATURED_LOAN_ATTRIBUTES), function (labels, value, key) {
  var legacyValue = MORTGAGES_LOAN_PRODUCTS[key] || MORTGAGES_LOAN_TYPES[key];
  var label = MORTGAGES_LOAN_PRODUCT_LABELS[legacyValue] || MORTGAGES_LOAN_TYPE_LABELS[legacyValue];
  return _objectSpread(_objectSpread({}, labels), {}, _defineProperty({}, value, label));
}, {});
/**
 * Insurance product sub product types.
 *
 * Should match https://github.com/NerdWallet/marketplace/blob/44030a82b26b37ec5bde13379afafa11adc84f22/src/schemas/insurance/product_details.json#L3
 *
 * @type       {Object}
 */

export var INSURANCE_SUB_PRODUCT_TYPES = {
  APPLIANCE: 'appliance',
  AUTO: 'Auto',
  BOAT_MARINE: 'boat-marine',
  CAR: 'car',
  CLASSIC_CAR: 'classic-car',
  DISABILITY: 'disability',
  EARTHQUAKE: 'earthquake',
  FLOOD: 'flood',
  FUNERAL: 'funeral',
  HOME: 'Home',
  HOMEOWNERS_PROPERTY: 'homeowners-property',
  IDENTITY_THEFT: 'identity-theft',
  LIABILITY_UMBRELLA: 'liability-umbrella',
  LIFE: 'life',
  LIFE_SUB: 'Life',
  LONG_TERM_CARE: 'long-term-care',
  MEDIAALPHA_CPC: 'mediaalpha-cpc',
  MOTORCYCLE_MOTORBIKE: 'motorcycle-motorbike',
  PERSONAL_PROPERTY: 'personal-property',
  PET: 'pet',
  PET_SUB: 'Pet',
  RENTAL_CAR: 'rental-car',
  RENTERS_SUB: 'Renters',
  RENTERS: 'renters',
  TERM_LIFE: 'term-life',
  TRAVEL: 'travel',
  UNIVERSAL_LIFE: 'universal-life',
  VACATION: 'vacation',
  VARIABLE_LIFE: 'variable-life'
};
/**
 * Canonical Institution Types
 *
 * Should match https://github.com/NerdWallet/marketplace/blob/f4347bc6ad888f1044d9099ee89fd197232e6574/src/marketplace/lib/enums.py#L20-L40
 *
 * @type {Object<String>}
 */

export var CANONICAL_INSTITUTION_TYPES = {
  BANK: 'bank',
  BROKER: 'broker',
  CANONICAL: 'canonical',
  CREDIT_UNION: 'credit_union',
  EMPLOYEES_CREDIT_UNION: 'empl_credit_union',
  FINANCIAL_CONSULTANT: 'financial_consultant',
  GOVERNMENT_BANK: 'government_bank',
  HOLDING_COMPANY: 'holding_company',
  INSURANCE_PROVIDER: 'insurance_provider',
  INTERNET_BANK: 'internet_bank',
  LOAN_PRODUCTION_OFFICE: 'loan_production_office',
  MORTGAGE_COMPANY: 'mortgage_company',
  NON_BANK_FINANCIAL_SERVICE_PROVIDER: 'non_bank_financial_service_provider',
  NON_DEPOSITORY: 'non_depository',
  OPERATIONS_OFFICE: 'operations_office',
  PLAID: 'plaid',
  SAVINGS_LOAN: 'savings_loan',
  TRUST_COMPANY: 'trust_company',
  UNKNOWN: 'unknown',
  US_BRANCH_OF_FOREIGN_BANK: 'us_branch_of_foreign_bank',
  YODLEE: 'yodlee'
};
/**
 * Legacy Ingested Institution Types (Specificallly used in `BANKING` ingestion).
 *
 * Should match https://github.com/NerdWallet/marketplace/blob/07e795a8a34f440a8b2929e0861b9a70bfc522cc/src/schemas/banking/institution_details.json#L135-L159
 *
 * @deprecated - As a strict subset of Canonical Institution Types, those should be used instead.
 * @see LEGACY_TO_CANONICAL_INSTITUTION_TYPES
 * @type {Object<String>}
 */

export var LEGACY_INSTITUTION_TYPES = {
  BANK: 'BK',
  BROKER: 'BR',
  CREDIT_UNION: 'CU',
  EMPLOYEES_CREDIT_UNION: 'EC',
  FINANCIAL_CONSULTANT: 'FC',
  GOVERNMENT_BANK: 'GB',
  HOLDING_COMPANY: 'HC',
  INTERNET_BANK: 'IB',
  LOAN_PRODUCTION_OFFICE: 'LP',
  MORTGAGE_COMPANY: 'MG',
  NON_BANK_FINANCIAL_SERVICE_PROVIDER: 'NBFSP',
  NON_DEPOSITORY: 'ND',
  OPERATIONS_OFFICE: 'OP',
  SAVINGS_LOAN: 'SL',
  TRUST_COMPANY: 'TC',
  US_BRANCH_OF_FOREIGN_BANK: 'FB'
};
/**
 * Mappings of legacy bank types to the canoncial bank types.
 *
 * @type {Object<String>}
 */

export var LEGACY_TO_CANONICAL_INSTITUTION_TYPES = _reduce(LEGACY_INSTITUTION_TYPES, function (institutionTypes, legacyValue, key) {
  return _objectSpread(_objectSpread({}, institutionTypes), {}, _defineProperty({}, legacyValue, CANONICAL_INSTITUTION_TYPES[key]));
}, {});
/**
 * Entity status values
 *
 * Should match https://github.com/NerdWallet/marketplace/blob/76fa68183892ac98065f481ac43bd05d22cd7c3c/src/marketplace/lib/enums.py#L16
 *
 * @type {string}
 */

export var STATUSES = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};
/**
 * Entity status values
 *
 * @type {string}
 * @deprecated Deprecated in favor of STATUSES
 */

export var ACTIVE_STATUS = STATUSES;
/**
 * Annotation for FDIC institutions
 */

export var FDIC_ANNOTATION = 'Member FDIC';
/**
 * Annotation for NCUA institutions
 */

export var NCUA_ANNOTATION = 'Federally insured by NCUA';
/**
 * Annotation for NON_MEMBER_FDIC institutions
 */

export var NON_MEMBER_FDIC_ANNOTATION = 'Deposits are FDIC Insured';
/**
 * Federally insured types
 *
 * Should match https://github.com/NerdWallet/marketplace/blob/9a449e1a02ef7b7e814ff294b5991d10d5d0ad61/src/schemas/banking/institution_details.json#L33
 *
 * @type {string}
 */

export var FEDERALLY_INSURED_TYPES = {
  FDIC: 'FDIC',
  NCUA: 'NCUA',
  NON_MEMBER_FDIC: 'NON_MEMBER_FDIC'
};
/**
 * Mapping of "federally insured types" to their respective annotations.
 *
 * @type {Object<String>}
 */

export var FEDERALLY_INSURED_ANNOTATIONS = (_FEDERALLY_INSURED_AN = {}, _defineProperty(_FEDERALLY_INSURED_AN, FEDERALLY_INSURED_TYPES.FDIC, FDIC_ANNOTATION), _defineProperty(_FEDERALLY_INSURED_AN, FEDERALLY_INSURED_TYPES.NCUA, NCUA_ANNOTATION), _defineProperty(_FEDERALLY_INSURED_AN, FEDERALLY_INSURED_TYPES.NON_MEMBER_FDIC, NON_MEMBER_FDIC_ANNOTATION), _FEDERALLY_INSURED_AN);
/**
 * Monetization statuses for use in product shopping events (e.g. shopping_finished event). Must match the schema in
 * https://github.com/NerdWallet/app-schemata/blob/ccf84b8e5b32ac7c1fb91e7d5bdf5f8b3c1ed881/analytic_pipeline/product_shopping_attributes.yaml#L40
 */

export var MONETIZATION_STATUSES = {
  YES_ASSUMED: 'yes_assumed',
  NO: 'no',
  NO_BECAUSE_OF_LIMIT: 'no_because_of_limit',
  NO_BECAUSE_OF_LEAD: 'no_because_of_lead'
};
/**
 * Label Map for Mortages labels
 */

export var MIN_CREDIT_SCORE_TOOLTIP_TYPES_AND_LABELS = _objectSpread(_objectSpread({}, MORTGAGES_CANONICAL_LOAN_TYPES), MORTGAGES_FEATURED_LOAN_ATTRIBUTES);
/**
 * Enum for Personal Loans Expanded Marketplace Categories
 * @see {@link https://github.com/NerdWallet/marketplace/blob/master/src/schemas/personal_loans/offer_details.json#L148-L159|Marketplace Schema}
 * @readonly
 * @enum {string}
 */

export var PERSONAL_LOANS_EXPANDED_MARKETPLACE_CATEGORIES = {
  BANKRUPTCY: 'BANKRUPTCY',
  CONTINGENT: 'CONTINGENT',
  CO_SIGN_LOANS: 'CO_SIGN_LOANS',
  CREDIT_BUILDER_LOANS: 'CREDIT_BUILDER_LOANS',
  DEBT_MANAGEMENT_PLANS: 'DEBT_MANAGEMENT_PLANS',
  FRIENDS_FAMILY_LOANS: 'FRIENDS_FAMILY_LOANS',
  HIGH_INTEREST_PERSONAL_LOANS: 'HIGH_INTEREST_PERSONAL_LOANS',
  HOME_EQUITY_LOANS: 'HOME_EQUITY_LOANS',
  PAYCHECK_ADVANCE: 'PAYCHECK_ADVANCE',
  SECURED_LOANS: 'SECURED_LOANS'
};
/**
 * Enum for Software Product Categories
 * @see {@link https://github.com/NerdWallet/marketplace/blob/08c6d3a6a5572bcb078d1a18e8098714f4a5283d/src/schemas/software/product_details.json#L11-L16|Marketplace Schema}
 * @readonly
 * @enum {string}
 */

export var SOFTWARE_SUB_PRODUCT_TYPES = {
  ACCOUNTING: 'ACCOUNTING',
  PAYROLL: 'PAYROLL',
  PAYMENTS: 'PAYMENTS',
  LEGAL: 'LEGAL',
  INSURANCE: 'INSURANCE'
};